<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_120_202)">
      <path
        d="M1.5 16.5H9.75C10.6364 16.5 11.5142 16.3254 12.3331 15.9862C13.1521 15.647 13.8962 15.1498 14.523 14.523C15.1498 13.8962 15.647 13.1521 15.9862 12.3331C16.3254 11.5142 16.5 10.6364 16.5 9.75C16.5 8.86358 16.3254 7.98583 15.9862 7.16689C15.647 6.34794 15.1498 5.60382 14.523 4.97703C13.8962 4.35023 13.1521 3.85303 12.3331 3.51381C11.5142 3.17459 10.6364 3 9.75 3C6.27525 3 3.37275 5.625 3 9M13.875 4.125L14.625 3.375M4.125 3.375L4.875 4.125"
        stroke="#E32A2A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M12.375 6.75L10.17 8.955C10.0662 8.84755 9.94208 8.76185 9.80483 8.70289C9.66758 8.64393 9.51995 8.61289 9.37058 8.61159C9.2212 8.6103 9.07306 8.63876 8.9348 8.69533C8.79654 8.75189 8.67093 8.83543 8.56531 8.94106C8.45968 9.04669 8.37614 9.17229 8.31958 9.31055C8.26301 9.44881 8.23454 9.59695 8.23584 9.74633C8.23714 9.8957 8.26818 10.0433 8.32714 10.1806C8.3861 10.3178 8.4718 10.442 8.57925 10.5457C8.7903 10.7568 9.07654 10.8754 9.375 10.8754C9.67346 10.8754 9.9597 10.7568 10.1707 10.5457C10.3818 10.3347 10.5004 10.0485 10.5004 9.75C10.5004 9.45154 10.3818 9.1653 10.1707 8.95425M9.375 2.625V1.5M7.875 1.5H10.875M1.5 11.25H3.75M1.5 14.25H5.25"
        stroke="#E32A2A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_120_202">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "ClockIcon",
}
</script>

<style lang="scss" scoped>
</style>